(() => {
  function init(root) {
    if (root.dataset.ready) return;
    const controls = root.querySelector('[data-controls]');
    const search = root.querySelector('#p2-search');
    const status = root.querySelector('#p2-status');
    const counter = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-no-results]');
    const cards = Array.from(root.querySelectorAll('[data-part-record]'));
    if (!controls || !search || !status || !counter || !empty) return;
    const normalise = value => value.toLowerCase().normalize('NFKC').replace(/[\s\-–—]+/g, '');
    const index = cards.map(card => ({card, text: normalise(card.textContent)}));
    function update() {
      const query = normalise(search.value.trim());
      let visible = 0;
      index.forEach(({card, text}) => {
        const match = text.includes(query) && (!status.value || card.dataset.status === status.value);
        card.hidden = !match;
        if (match) visible++;
      });
      counter.textContent = counter.dataset.countTemplate.replace('__COUNT__', visible).replace('__TOTAL__', cards.length);
      empty.hidden = visible !== 0;
    }
    search.addEventListener('input', update);
    status.addEventListener('change', update);
    root.querySelector('[data-reset]').addEventListener('click', () => {search.value = ''; status.value = ''; update(); search.focus();});
    const dialog = root.querySelector('[data-part-dialog]');
    if (dialog) {
      const dialogTitle = dialog.querySelector('[data-dialog-title]');
      const dialogRecord = dialog.querySelector('[data-dialog-record]');
      root.addEventListener('click', event => {
        const trigger = event.target.closest('[data-open-part]');
        if (!trigger) return;
        const card = trigger.closest('[data-part-record]');
        if (!card) return;
        dialogTitle.textContent = trigger.textContent.trim();
        dialogRecord.innerHTML = '';
        Array.from(card.children).slice(1).forEach(child => dialogRecord.appendChild(child.cloneNode(true)));
        dialog.showModal();
      });
      dialog.querySelector('[data-close-part]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    }
    root.dataset.ready = 'true';
    controls.hidden = false;
    update();
  }
  document.querySelectorAll('[data-p2-database]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-p2-database]').forEach(init));
})();
